import React from "react";

interface CommandCenterSplashGCLogoProps {
    teamLogo?: string;
    project?: any;
}

const CommandCenterSplashGCLogo: React.FC<CommandCenterSplashGCLogoProps> = ({ teamLogo, project }) => {
    return <div></div>;
};

export default CommandCenterSplashGCLogo;
